<template>
  <landing-layout>
    <template slot="layout-left">
      <welcome-slogan />
    </template>
    <template slot="layout-right">
      <reset-password-form v-if="!isSuccess" :on-submit="submit" :on-go-back="goBack" :errors="errors" :is-loading="isLoading" />
      <message-box v-if="isSuccess" className="is-success" :message="$t('landing.reset_password.success_message', {loginRoute: '/login'})"/>
    </template>
  </landing-layout>
</template>

<script>
import LandingLayout from '@/components/layouts/LandingLayout.vue'
import WelcomeSlogan from '@/components/landing/WelcomeSlogan.vue'
import ResetPasswordForm from '@/components/landing/ResetPasswordForm.vue'
import MessageBox from '@/components/landing/MessageBox.vue'
import LoginApi from '@/api/security/login'
import Utils from '@/helper/utils'

export default {
  components: {
    LandingLayout,
    WelcomeSlogan,
    ResetPasswordForm,
    MessageBox,
  },
  data() {
    return {
      isLoading: false,
      isSuccess: false,
      errors: [],
    }
  },
  methods: {
    async submit(payload) {
      const token = Utils.getParamFromBrowserUrl('token')

      LoginApi.resetPassword(token, payload.password)
        .then(() => {
          this.isSuccess = true
          this.errors = []
        })
        .catch((error) => {
          this.errors.push(error.response.data.errors)
        })
    },
    goBack() {
      this.$router.push({ name: 'login' })
    },
  },
}
</script>
